import React, { useState } from "react";
import { del, get, post } from "../lib/api";
import { Button, Input } from "../ui";
import { useShell } from "../shell/context";

// Tags on a contact, company or lead (POST/DELETE /v1/crm/:entity/:id/tags/:tag).
export default function TagEditor({ entity, id, tags, onChange }) {
    const { toast } = useShell();
    const [adding, setAdding] = useState(false);
    const [value, setValue] = useState("");
    const [suggestions, setSuggestions] = useState([]);

    const add = async (name) => {
        const tag = (name || value).trim();
        if (!tag) return;
        try {
            const res = await post(`v1/crm/${entity}/${id}/tags/${encodeURIComponent(tag)}`);
            onChange(res.tags || []);
            setValue("");
            setSuggestions([]);
        } catch (e) {
            toast(e.message, { error: true });
        }
    };
    const remove = async (tag) => {
        try {
            const res = await del(`v1/crm/${entity}/${id}/tags/${encodeURIComponent(tag)}`);
            onChange((res && res.tags) || tags.filter((t) => t !== tag));
        } catch (e) {
            toast(e.message, { error: true });
        }
    };
    const suggest = async (q) => {
        setValue(q);
        if (!q.trim()) return setSuggestions([]);
        try {
            const res = await get("v1/crm/tags", { q: q.trim() });
            setSuggestions((res.data || []).map((t) => t.name).filter((n) => !tags.includes(n)).slice(0, 6));
        } catch (e) {
            setSuggestions([]);
        }
    };

    return (
        <div>
            <div className="hz-row-wrap" style={{ gap: 6 }}>
                {tags.length === 0 && !adding && <span className="hz-muted">No tags.</span>}
                {tags.map((t) => (
                    <span key={t} className="hz-tag">
                        {t}
                        <button type="button" aria-label={`Remove ${t}`} onClick={() => remove(t)}>
                            <i className="ri-close-line"></i>
                        </button>
                    </span>
                ))}
                {!adding && (
                    <Button size="sm" variant="ghost" icon="ri-add-line" onClick={() => setAdding(true)}>Tag</Button>
                )}
            </div>
            {adding && (
                <div style={{ marginTop: 8 }}>
                    <div className="hz-row" style={{ gap: 6 }}>
                        <Input
                            small
                            autoFocus
                            value={value}
                            placeholder="segment:fintech"
                            onChange={(e) => suggest(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") add();
                                if (e.key === "Escape") setAdding(false);
                            }}
                        />
                        <Button size="sm" variant="primary" onClick={() => add()}>Add</Button>
                        <Button size="sm" variant="light" onClick={() => { setAdding(false); setValue(""); setSuggestions([]); }}>Done</Button>
                    </div>
                    {suggestions.length > 0 && (
                        <div className="hz-row-wrap" style={{ gap: 4, marginTop: 6 }}>
                            {suggestions.map((s) => (
                                <button key={s} type="button" className="hz-chip hz-chip-sm" onClick={() => add(s)}>{s}</button>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
